import { state } from '../core/state.js';
import { esc } from '../core/text.js';
import { SFX, toast } from '../ui/toast.js';
import { GAME } from './data.js';
import { G, gStats } from './items.js';
import { RPG } from './ui.js';
import { gEnsureObstacle, gSectionMeta } from './world.js';

/* ═══════════ Wissensduell-Kampfscreen (aktives Lernen im Abenteuer) ═══════════ */
export let battleTimer = null;
export function battleFmtTime(ms) {
  const s = Math.max(0, Math.floor(ms / 1000)); return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
}
export function renderBattleHud() {
  const host = document.getElementById('battle-hud'); if (!host) return;
  const g = G(); const s = state.session; const st = gStats(); gEnsureObstacle();
  const ob = g.obstacle; const m = gSectionMeta(g.section);
  const pct = Math.max(0, Math.round((ob.hp / ob.maxHp) * 100));
  host.className = 'bhud' + (ob.isExam ? ' exam' : '');
  host.style.backgroundImage = `url(${RPG(m.bg)})`;
  host.innerHTML = `
    <div class="bhud-hero">
      <div class="sprite-stage"><img class="pixel-sprite bhud-hero-img" src="${RPG('hero.png')}" alt="Mimorio"></div>
      <div class="bhud-hero-info">
        <div class="bhud-name">Mimorio</div>
        <div class="bhud-substat" title="Wie stark dein Angriff trifft – steigt mit gelernten (reifen) Karten und deinen Verbesserungen.">Angriffskraft</div><div class="bhud-know">✦ ${Math.round(st.knowledge)}</div>
        <div class="bhud-hearts">❤️❤️❤️</div>
        <div class="bhud-lv" title="Deine Lernstufe im Abenteuer – steigt durchs Lernen.">Lv. ${g.charLvl}</div>
      </div>
    </div>
    <div class="bhud-mid">
      <div class="bhud-center">
        <div class="bhud-col"><span>KOMBO</span><b class="c-green" id="bhud-combo">x${s ? (s.combo || 0) : 0}</b></div>
        <div class="bhud-col" title="Wie stark dein Angriff trifft."><span>ANGRIFFSKRAFT</span><b class="c-gold">${Math.round(st.knowledge)}</b></div>
        <div class="bhud-col"><span>KARTENFORTSCHRITT</span><b class="c-cream" id="bhud-progress">${s ? s.i + 1 : 1} / ${s ? s.target : 0}</b></div>
      </div>
      <div class="bhud-strip">
        <span>🗂 Karte <b id="bhud-cardn">${s ? s.i + 1 : 1} / ${s ? s.target : 0}</b></span>
        <span>🔥 Serie x<b id="bhud-serie">${s ? (s.combo || 0) : 0}</b></span>
        <span>⏱ <b id="bhud-time">00:00</b></span>
        <span><img src="assets/icon_coin.png" alt="">Belohnung +<b id="bhud-reward">${s ? (s.reward || 0) : 0}</b></span>
      </div>
    </div>
    <div class="bhud-enemy">
      <div class="bhud-ename" id="bhud-ename">${esc(ob.name)}${ob.isExam ? ' 📜' : ''}</div>
      <div class="enemy-health"><div class="enemy-health__fill" id="bhud-hp" style="width:${pct}%"></div></div>
      <div class="bhud-ehp" id="bhud-hptext">${Math.max(0, ob.hp)} / ${ob.maxHp} HP</div>
      <div class="sprite-stage enemy ${(ob.sprites && ob.sprites.length > 1) ? 'group' : ''} ${ob.elite ? 'elite' : ''}" id="bhud-enemy-stage" data-sig="${(ob.sprites || []).map((s) => s.img).join(',')}">${battleEnemyImgsHTML(ob, m)}</div>
    </div>`;
  clearInterval(battleTimer);
  battleTimer = setInterval(() => {
    if (!state.session || !state.session.battle || state.view !== 'study') { clearInterval(battleTimer); battleTimer = null; return; }
    const t = document.getElementById('bhud-time'); if (t) t.textContent = battleFmtTime(Date.now() - state.session.startedAt);
  }, 1000);
}
export function battleUpdateHud() {
  const g = G(); const s = state.session; if (!s) return; const ob = g.obstacle; if (!ob) return;
  const m = gSectionMeta(g.section);
  const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
  set('bhud-progress', `${s.i + 1} / ${s.target}`); set('bhud-cardn', `${s.i + 1} / ${s.target}`);
  set('bhud-combo', 'x' + (s.combo || 0)); set('bhud-serie', s.combo || 0); set('bhud-reward', s.reward || 0);
  set('bhud-ename', ob.name + (ob.isExam ? ' 📜' : ''));
  const hp = document.getElementById('bhud-hp'); if (hp) hp.style.width = Math.max(0, Math.round((ob.hp / ob.maxHp) * 100)) + '%';
  set('bhud-hptext', `${Math.max(0, ob.hp)} / ${ob.maxHp} HP`);
  // Gegner-Sprites nur neu aufbauen, wenn sich das Hindernis geändert hat (sonst Trefferanimation nicht stören).
  const stage = document.getElementById('bhud-enemy-stage');
  if (stage) {
    const sig = (ob.sprites && ob.sprites.length ? ob.sprites : [{ img: m.enemy }]).map((s) => s.img).join(',');
    if (stage.dataset.sig !== sig) {
      stage.dataset.sig = sig;
      stage.className = 'sprite-stage enemy ' + ((ob.sprites && ob.sprites.length > 1) ? 'group ' : '') + (ob.elite ? 'elite' : '');
      stage.innerHTML = battleEnemyImgsHTML(ob, m);
    }
  }
}
export function battleEnemyImgsHTML(ob, m) {
  const sprites = (ob.sprites && ob.sprites.length) ? ob.sprites : [{ img: m.enemy, boss: ob.isExam }];
  return sprites.map((sp, i) => `<img class="pixel-sprite bhud-enemy-img ${sp.boss ? 'boss' : 'is-side'}" ${i === 0 ? 'id="bhud-enemy-img"' : ''} src="${RPG(sp.img)}" alt="" title="${esc(sp.name || ob.name)}">`).join('');
}
export function ratingDamageRange(rating) {
  const st = gStats(); const mult = GAME.ratingDmg[rating] || 1;
  const lo = Math.max(1, Math.round(st.knowledge * mult));
  const hi = Math.max(lo, Math.round(st.knowledge * mult * GAME.critMult));
  return { lo, hi };
}
export function renderBattleSidebar() {
  const host = document.getElementById('battle-sidebar'); if (!host) return;
  const g = G(); const st = gStats();
  const base = ratingDamageRange('good');
  const ob = g.obstacle || {};
  const coinRew = Math.round(GAME.obstacle.reward * Math.pow(GAME.obstacle.rewardG, g.section) * (ob.isExam ? GAME.exam.rewardMult : 1) * st.collect * (1 + st.coinBonus));
  const fokusReady = (g.focusEnergy || 0) >= GAME.fokusMax;
  const focus = Math.min(GAME.fokusMax, g.focusEnergy || 0); const focusPct = Math.round(focus / GAME.fokusMax * 100);
  const chestProg = Math.round(g.chestProgress || 0); const chestPct = Math.min(100, chestProg);
  host.innerHTML = `
    <div class="bside-card">
      <div class="bside-h">🔮 Möglicher Angriff</div>
      <div class="bside-sub">So viel Schaden macht deine Wahl (fahr über einen Knopf):</div>
      <div class="bside-atkrow"><div class="bside-atkval" id="bside-atk">${base.lo}–${base.hi}</div><img class="bside-sword" src="${RPG('reward.png')}" alt=""></div>
    </div>
    <div class="bside-card">
      <div class="bside-h">🎁 Belohnung bei Sieg</div>
      <div class="bside-rew"><span><img src="assets/icon_coin.png" alt="">+${coinRew} Wissensmünzen</span></div>
      <div class="bside-note"><b>Sieg</b> = ${esc(ob.name || 'Hindernis')} auf 0 HP bringen. Die Münzen bekommst du sofort gutgeschrieben.${ob.isExam ? ' Prüfung → zusätzlich 1 💎 + Truhe!' : ''}</div>
    </div>
    <div class="bside-card ${fokusReady ? 'fokus-ready' : ''}">
      <div class="bside-h">⚡ Fokus &amp; Truhen</div>
      <div class="bside-meter"><span title="Füllt sich mit guten Antworten. Voll = dein nächster Angriff macht doppelten Schaden!">Fokus</span><div class="bside-bar green"><i style="width:${focusPct}%"></i></div><b>${fokusReady ? 'BEREIT!' : focus + ' / ' + GAME.fokusMax}</b></div>
      <div class="bside-fokusnote">${fokusReady ? '⚡ Nächster Angriff = Spezialangriff (doppelter Schaden)!' : 'Voll → nächster Angriff macht doppelten Schaden.'}</div>
      <div class="bside-meter" style="margin-top:8px"><span title="Füllt sich beim Lernen. Voll = eine gratis Schatztruhe!">Truhe</span><div class="bside-bar purple"><i style="width:${chestPct}%"></i></div><b>${chestProg} / 100</b></div>
      <div class="bside-fokusnote">Voll → gratis Schatztruhe. Truhen gibt's auch beim Besiegen von Hindernissen.</div>
    </div>
    <div class="bside-card">
      <div class="bside-h">📜 Session-Info</div>
      <p class="bside-info">Alle 10 Abschnitte kommt eine <b>Wissensprüfung</b> (Boss) – nur durch aktives Lernen zu bestehen und mit garantierter Truhe + 💎. Die Bosse werden stärker, bleib dran!</p>
    </div>`;
}
export function wireBattlePreview() {
  document.querySelectorAll('#answer-row .rate').forEach((b) => {
    b.addEventListener('mouseenter', () => {
      if (!state.session || !state.session.battle) return;
      const r = ratingDamageRange(b.dataset.rate); const el = document.getElementById('bside-atk');
      if (el) el.textContent = `${r.lo}–${r.hi}`;
    });
  });
}
/* Treffer-Sequenz: Stärke variiert je nach Bewertung; Fokus = Spezialangriff, Sieg = Explosion. */
export const ATK_TIER = { again: 'a1', hard: 'a2', good: 'a3', easy: 'a4' };
export function battleHit(hit) {
  if (!hit) return;
  const hero = document.querySelector('.bhud-hero-img');
  const estage = document.getElementById('bhud-enemy-stage');
  const eimg = document.getElementById('bhud-enemy-img');
  const hud = document.getElementById('battle-hud');
  const tier = hit.fokus ? 'a5' : (ATK_TIER[hit.rating] || 'a3');
  if (hero) { hero.className = 'pixel-sprite bhud-hero-img'; void hero.offsetWidth; hero.classList.add('attack', tier); }
  if (hit.fokus && hud) { const f = document.createElement('div'); f.className = 'bhud-fokusflash'; f.textContent = '⚡ FOKUS!'; hud.appendChild(f); setTimeout(() => f.remove(), 700); }
  if (hud) {
    const bolt = document.createElement('div');
    bolt.className = 'bhud-bolt ' + tier + (hit.crit ? ' crit' : '') + (hit.fokus ? ' fokus' : '');
    bolt.textContent = hit.fokus ? '⚡' : '✦';
    hud.appendChild(bolt); setTimeout(() => bolt.remove(), 460);
  }
  setTimeout(() => {
    if (estage) {
      // 'group'-Klasse erhalten, nur Treffer-Klassen neu setzen (Reflow für Re-Trigger).
      estage.classList.remove('hit', 'a1', 'a2', 'a3', 'a4', 'a5'); void estage.offsetWidth; estage.classList.add('hit', tier);
      // Leucht-/Überhelligkeits-Effekt nach der Trefferanimation wieder entfernen (Gegner sonst zu hell).
      setTimeout(() => { if (estage) estage.classList.remove('hit', tier); }, 380);
    }
    battleUpdateHud();
    if (estage) {
      const dn = document.createElement('div'); dn.className = 'bhud-dmg ' + tier + (hit.crit ? ' crit' : '');
      dn.textContent = (hit.crit ? '✦ ' : '') + '-' + hit.dmg; estage.appendChild(dn); setTimeout(() => dn.remove(), 950);
    }
  }, 300);
  if (hit.shieldBroke) setTimeout(() => toast('🛡️💥 Boss-Schild zerbrochen – jetzt voller Schaden!'), 320);
  else if (hit.shieldHit) setTimeout(() => toast(`🛡️ Boss-Schild hält (noch ${hit.shield})`), 320);
  if (hit.defeated) {
    const allImgs = estage ? estage.querySelectorAll('.bhud-enemy-img') : [];
    setTimeout(() => { if (estage) battleBoom(estage, hit.exam); allImgs.forEach((im) => im.classList.add('defeated')); try { SFX.win(); } catch (e) {} }, 360);
    setTimeout(() => { battleUpdateHud(); allImgs.forEach((im) => im.classList.remove('defeated')); renderBattleSidebar(); }, 900);
    if (!hit.exam) toast(`💥 Hindernis besiegt! +${hit.reward} Münzen`);   // Boss-Sieg zeigt stattdessen das „Welt befreit"-Popup
    if (!hit.exam && (hit.chest || hit.meterChest)) setTimeout(() => toast('🎁 Eine Schatztruhe gefunden!'), 850);
  } else if (hit.meterChest) {
    setTimeout(() => toast('🎁 Truhen-Meter voll – gratis Schatztruhe!'), 400);
  }
}
/* Explosions-Effekt beim Besiegen eines Gegners */
export function battleBoom(stage, big) {
  const boom = document.createElement('div'); boom.className = 'bhud-boom'; stage.appendChild(boom);
  const n = big ? 16 : 11;
  for (let i = 0; i < n; i++) {
    const p = document.createElement('span'); p.className = 'boom-p';
    const ang = (Math.PI * 2 * i) / n; const dist = (big ? 70 : 52) + (i % 3) * 10;
    p.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
    p.style.setProperty('--dy', Math.sin(ang) * dist + 'px');
    boom.appendChild(p);
  }
  setTimeout(() => boom.remove(), 700);
}

